import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from '@hrms/ui';
import { tsr } from '../../../lib/api.js';
import { SETUP_STATUS_KEY } from './setupProgress.js';

/** The setup-status query under the key every other reader uses. */
export function useSetupStatus(enabled: boolean) {
  return tsr.setupStatus.getSetupStatus.useQuery({
    queryKey: [...SETUP_STATUS_KEY],
    enabled,
  });
}

/**
 * Hides (or, with 0 days, shows again) the Getting started panel for this company, server side.
 * `hiddenLocally` flips at once so the panel goes without waiting for the refetch.
 */
export function useHidePanel() {
  const queryClient = useQueryClient();
  const mutation = tsr.setupStatus.updateSetupPreferences.useMutation();
  const [hiddenLocally, setHiddenLocally] = useState(false);

  async function hideFor(days: number) {
    try {
      const result = await mutation.mutateAsync({ body: { hideChecklistForDays: days } });
      if (result.status !== 200) throw result;
      setHiddenLocally(days > 0);
      void queryClient.invalidateQueries({ queryKey: [...SETUP_STATUS_KEY] });
    } catch {
      toast.error('Could not save that. Try again.');
    }
  }

  return { hideFor, isPending: mutation.isPending, hiddenLocally };
}
